import { Link } from "@StarberryUtils";
import React,{useEffect} from "react";
import {Col, Row, Container } from 'react-bootstrap';
import  "./Similar.scss";
import Slider from 'react-slick';
import mainImg01 from "../../../images/main-img01.jpg"
import mainVideo01 from "../../../images/main-video01.jpg"
import smallImg01 from "../../../images/main-secondary01.jpg"
import mainImg02 from "../../../images/main-img02.jpg"
import mainVideo02 from "../../../images/main-video02.jpg"
import smallImg02 from "../../../images/main-secondary02.jpg"
import mainImg03 from "../../../images/main-img03.jpg"
import mainVideo03 from "../../../images/main-video03.jpg"
import smallImg03 from "../../../images/main-secondary03.jpg"
// import mainImg04 from "../../../images/main-img04.jpg"
// import mainVideo04 from "../../../images/main-video04.jpg"
// import smallImg04 from "../../../images/main-secondary04.jpg"
import FloorPlanModal from "../../property-search/floorPlanModal";
import $ from "jquery";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";

import { useQuery } from '@apollo/client';
import gql from "graphql-tag"

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import SaveProperty from "../SaveProperty";

import {
  isIOS,
  isMobileOnly,
  isBrowser,
  isMobile
} from "react-device-detect";

const myaccountURL = process.env.GATSBY_MYACCOUNT_URL || '';

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}
const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}
const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    }
  }
}
const contentItem = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
}
const MotionCol = motion(Col)


// const SIMILAR_PROP = gql`
// query GetAreaDetails ($Prop_Postcode: String!){
//     properties(where:{display_address_contains:$Prop_Postcode},limit:3) {
//       title
//       display_address
//       search_type
//       slug
//       id
//       images
//       floorplan
//       price
//     }
// }
// `;


  const Similar=(props)=>{

  //   const { loading, error, data } = useQuery(SIMILAR_PROP, {
  //     variables: { Prop_Postcode: props.postcode }
  // });

    const addingClass = (e) =>{
        let lexicalE = e.persist();
                let dm = document.getElementsByClassName("active-map")
                // console.log("testing",dm)
                if(dm.length ==0 ) {
                 if(document.querySelector('.active-map')!==null){
                    document.querySelector('.active-map').classList.remove('active-map')
                    e.target.classList.add("active-map")
            }
                    e.target.classList.add("active-map")

                } else {

               document.querySelector('.active-map').classList.remove('active-map')
        }
            // console.log("test",e.target.className ,dm)
    }
    const settings =  {
        dots: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: isMobile ? true : false,
        arrows: false,
        autoplay: true,
        
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
      const settings2 = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        mobileFirst:true,
        responsive: [
          {
            breakpoint: 767,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: true,
                }
          },
          {
              breakpoint: 9999,
              settings: "unslick"
          }

      ]
      }


      useEffect(() => {
        // Scroll to map
        let params = (new URL(document.location)).searchParams;
        let property_mapid = params.get('id');
        if(property_mapid) {
          setTimeout(function(){
            $('html, body').animate({
              scrollTop: $("#propertymap").offset().top-100
          }, 1000);
           }, 1000);


        }
        // Scroll to map
      }, []);

  // if (loading) return <div className="property-details-similar-loading">Loading ...</div>;

  return(
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.section
          className="similar-sec"
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
        {props.data && props.data.length > 0 &&
          <Container>

            <motion.div variants={titleVariants}>
              <h2 className="sec-title d-md-none">{props.Title}</h2>
              <h2 className="sec-title d-none d-md-block">{props.Title}</h2>
            </motion.div>
            <Row>
              <MotionCol
                lg={12}
                variants={container}
              >
                <Slider className="property-slider"  {...settings} >
                {props.data.map((item, index) => {

                      // property details url structure
                      let uriStr = "";

                      if( item.search_type === "sales" ) {
                        uriStr = `property-for-sale/`
                      } else if ( item.search_type === "lettings" ) {
                        uriStr = `property-to-rent/`
                      }

                      if (props.tag == "commercial") {
                        if( item.search_type === "sales" ) {
                          uriStr = `commercial-property-for-sale/`
                        } else if ( item.search_type === "lettings" ) {
                          uriStr = `commercial-property-to-rent/`
                        }
                      }

                      if (props.tag == "new-homes") {
                        if( item.search_type === "sales" ) {
                          uriStr = `new-homes-for-sale/`
                        } else if ( item.search_type === "lettings" ) {
                          uriStr = `new-homes-to-rent/`
                        }
                      }
                      // property details url structure

                      return(
                        <>
                        <motion.div className="slide-item" key={index} variants={contentItem}>
                          <div className="similar-property-card d-md-flex flex-wrap">
                              <div className="view-part1">
                                  <Slider className="main-slider" {...settings2} >
                                      <div className="main-item">
                                          <Link to={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()}>
                                            {item?.images[0]?.hd_url ? <img src={item?.images[0]?.hd_url} alt={`${props.property_title}+  - Martyn Gerrard`} /> :
                                            <ImageTransform imagesources={item?.images[0]?.url} renderer="srcSet" imagename="property.images.similar_properties" attr={{ alt: props.property_title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={props.processedImages} id={props.id}/>}
                                          </Link>
                                          <div className="on-map d-flex">
                                          <a href={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()+'?id=propertymap'} onClick={e=>addingClass(e)}><i className="icon-location"></i> <span className="exp-txt text-uppercase">View on Map</span></a>
                                              {/* <Link href="#"><i className="icon-map-view"></i></Link> */}
                                              {(item.floorplan ? ((item.floorplan.length > 0) ? <FloorPlanModal processedImagesFloorplan={props.processedImagesFloorplan} floorplanimg={item.floorplan[0].hd_url || item.floorplan[0].url} /> : ''):'')}
                                          </div>
                                      </div>
                                      <div className="main-item d-md-none">
                                      <Link to={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()}>
                                      {item?.images[1]?.hd_url ? <img src={item?.images[1]?.hd_url} alt={`${props.property_title}+  - Martyn Gerrard`} /> :
                                            <ImageTransform imagesources={item?.images[1]?.url} renderer="srcSet" imagename="property.images.similar_properties" attr={{ alt: props.property_title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={props.processedImages} id={props.id}/>}
                                          </Link>
                                          <a className="play-btn" href="#"><i className="icon-play-icon"></i></a>
                                      </div>
                                      <div className="main-item d-md-none">
                                      <Link to={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()}>
                                      {item?.images[2]?.hd_url ? <img src={item?.images[2]?.hd_url} alt={`${props.property_title}+  - Martyn Gerrard`} /> :
                                            <ImageTransform imagesources={item?.images[2]?.url} renderer="srcSet" imagename="property.images.similar_properties" attr={{ alt: props.property_title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={props.processedImages} id={props.id}/> }
                                          </Link>  
                                      </div>
                                  </Slider>
                              </div>
                              <div className="content-wrapper">
                                  <a className="card-details" href={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()}>
                                    <div className="detail-head d-flex align-items-center justify-content-between">
                                        <div className="sec-title price-title">
                                          {
                                            item?.price_qualifier === "POA" ? item?.price_qualifier : <><span className="price_qua_price">&pound;{item.price.toLocaleString()}</span></>
                                          }
                                        </div>
                                    </div>
                                    <span className="address-title d-block">{item.display_address}</span>
                                    <span className="prop-title d-block">{item.title}</span>
                                    {/* <div className="d-flex">
                                        <span className="distance d-flex align-items-center"><i className="icon-station"></i> 0.4 miles</span>
                                        <span className="distance d-flex align-items-center"><i className="icon-schools"></i> 0.63 miles</span>
                                    </div> */}
                                  </a>
                                  <SaveProperty type="property" pid={item.id} noTitle={true} />
                                </div>
                          </div>
                        </motion.div>
                        </>
                      )
                    })}
                </Slider>
              </MotionCol>
            </Row>
          </Container>
          }
        </motion.section>
      )}
    </InView>
  )
}

export default Similar
